let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hjKX1")).then(() => parcelRequire('a3ED6'));